import { LockIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Lock = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <LockIcon {...rest} weight="regular" size={Sizes[size]} color={fill} />;
};

Lock.displayName = 'Lock';
